import type { TelemetryClient } from '@klareospace/pharos-lib-front-utils';
import { toTelemetryAuthContext } from '@klareospace/pharos-lib-front-utils';
import * as React from 'react';
import { useEffect } from 'react';

export interface TelemetryBridgeProps {
  children: React.ReactNode;
  /** Klareo JWT string, or null when the user is unauthenticated. Provided by the consuming app. */
  klareoToken: string | null;
  /** Telemetry client to update with the decoded auth context. */
  telemetryClient: TelemetryClient;
}

/**
 * Sets the telemetry auth context from the Klareo JWT.
 *
 * Receives the current `klareoToken` via the `klareoToken` prop, decodes it via
 * `toTelemetryAuthContext`, and calls `telemetryClient.setAuthContext` whenever the
 * token changes. When no valid context can be derived the auth context is cleared
 * (set to `null`), which resets tenantId/userId to their anonymous defaults in the
 * telemetry client.
 */
export function TelemetryBridge({ children, klareoToken, telemetryClient }: TelemetryBridgeProps): React.JSX.Element {
  useEffect((): void => {
    telemetryClient.setAuthContext(toTelemetryAuthContext(klareoToken));
  }, [klareoToken, telemetryClient]);

  return <>{children}</>;
}
